/* English dictionary: room namespace. See src/i18n/README.md. */

import type { TextSpec } from '../text';

const room = {
  'room.noRoom': [ "Not in a room. Create one from the meetup page, or enter a room code to join." ],
  'room.backToMeetup': [ 'Back to meetup' ],
  'room.lobbyTitle': [ 'Players & Actions' ],
  'room.codeHint': [ 'Room code · Click to copy invite link' ],
  'room.players': [ 'Players' ],
  'room.playersCount': [ '· ', { type: 'param', name: 'n' }, '/', { type: 'param', name: 'max' } ],
  'room.randomFirst': [ 'Random first' ],
  'room.addBot': [ '+ Bot' ],
  'room.addTestPlayer': [ '+ Test player (dev)' ],
  'room.actions': [ 'Actions' ],
  'room.ready': [ 'Ready' ],
  'room.unready': [ 'Cancel ready' ],
  'room.hostValue': [ { type: 'param', name: 'name' }, ' (fastest network)' ],
  'room.waitingPlayers': [ 'Waiting for players' ],
  'room.waitingReady': [ 'Waiting for players to ready up' ],
  'room.startHotseat': [ 'Start game (hotseat)' ],
  'room.start': [ 'Start game' ],
  'room.cannotStart': [ "Cannot start yet" ],
  'room.leave': [ 'Leave room' ],
  'room.sync': [ 'Refresh sync' ],
  'room.syncRequested': [ 'Sync requested' ],
  'room.readonly': [ ' (read-only)' ],
  'room.deckTitle': [ 'Deck' ],
  'room.deckTotal': [ 'Total' ],
  'room.exportConfig': [ 'Export config' ],
  'room.importHint': [ 'Drag a config file onto the page to import' ],
  'room.imported': [ 'Imported: ', { type: 'param', name: 'name' } ],
  'room.creatorOnly': [ 'Only the room owner can change room settings.' ],
  'room.badge.creator': [ 'Owner' ],
  'room.badge.first': [ 'First' ],
  'room.kick': [ 'Kick' ],
  'room.packsTitle': [ 'Content Packs' ],
  'room.everyoneHas': [ 'Everyone has it' ],
  'room.autoByPlayerCount': [ 'Auto by player count ', { type: 'param', name: 'label' } ],
  'room.listSeparator': [ ', ' ],
  'room.error.addBotCreatorOnly': [ 'Only the creator can add a bot' ],
  'room.error.seatsFull': [ 'All seats are full' ],
  'room.error.kickCreatorOnly': [ 'Only the room creator can remove players' ],
  'room.error.kickSelf': [ "You cannot remove yourself" ],
  'room.error.playerGone': [ 'This player has left the room' ],
  'room.error.configCreatorOnly': [ 'Only the room creator can change the rules' ],
  'room.error.deckCreatorOnly': [ 'Only the room creator can change the deck' ],
  'room.error.countNumber': [ 'Count must be a number' ],
  'room.pack.missing': [ 'Missing: ', { type: 'param', name: 'names' } ],
  'room.pack.notReported': [ 'some players have not reported yet' ],
  'room.pack.versionMismatch': [ 'Version mismatch (same id, different hash)' ],
  'room.pack.nobodyHas': [ 'No player has this pack installed' ],
  'room.problem.minPlayers': [ 'At least ', { type: 'param', name: 'n' }, ' players required' ],
  'room.problem.maxPlayers': [ 'At most ', { type: 'param', name: 'n' }, ' players' ],
  'room.problem.notReady': [ { type: 'param', name: 'names' }, ' not ready' ],
  'room.problem.packDisabled': [ 'Content pack "', { type: 'param', name: 'id' }, '" cannot be enabled: ', { type: 'param', name: 'reason' } ],
  'room.problem.inconsistent': [ 'inconsistent' ],
} as const;

// 静态检查（写在对象字面量之外，避免 TextKey 循环推断）
room satisfies Record<string, TextSpec>;
export default room;
